import type {
  AdditionalPaymentInfoProps,
  ContractInfoProps,
  PaymentInfoProps,
  ManualPaymentInfoProps,
} from '@openeducation/pp-rn-shared-types';

import type { IsSubmitEnabledParams } from '../../hooks/use-is-submit-enabled';

interface GetIsSubmitEnabledParams {
  paymentInfoProps: Omit<PaymentInfoProps, 'renderCardPreview'>;
  additionalPaymentInfoProps?: AdditionalPaymentInfoProps;
  additionalPaymentInfo2Props?: AdditionalPaymentInfoProps;
  contractInfoProps?: ContractInfoProps;
  manualPaymentInfoProps?: ManualPaymentInfoProps;
}

export const getIsSubmitEnabledParams = ({
  paymentInfoProps,
  additionalPaymentInfoProps,
  additionalPaymentInfo2Props,
  contractInfoProps,
  manualPaymentInfoProps,
}: GetIsSubmitEnabledParams): IsSubmitEnabledParams => {
  return {
    paymentInfo: {
      fields: paymentInfoProps.fields,
      validation: paymentInfoProps.validation,
      formData: paymentInfoProps.formData,
    },
    ...(additionalPaymentInfoProps
      ? {
          additionalPaymentInfo: {
            fields: additionalPaymentInfoProps.fields,
            validation: additionalPaymentInfoProps.validation,
            formData: additionalPaymentInfoProps.formData,
            isCitySelectionEnabled:
              additionalPaymentInfoProps.selectData.city.length > 0,
          },
        }
      : {}),
    ...(additionalPaymentInfo2Props
      ? {
          additionalPaymentInfo2: {
            fields: additionalPaymentInfo2Props.fields,
            validation: additionalPaymentInfo2Props.validation,
            formData: additionalPaymentInfo2Props.formData,
            isCitySelectionEnabled:
              additionalPaymentInfo2Props.selectData.city.length > 0,
          },
        }
      : {}),
    ...(manualPaymentInfoProps
      ? {
          manualPaymentInfo: {
            fields: manualPaymentInfoProps.fields,
            validation: manualPaymentInfoProps.validation,
            formData: manualPaymentInfoProps.formData,
          },
        }
      : {}),
    ...(contractInfoProps
      ? {
          contractInfo: {
            validation: contractInfoProps.validation,
            checkedTerms: contractInfoProps.terms.checkedTerms,
            additionalTerms: contractInfoProps.terms.additionalTerms,
            freeTrial: contractInfoProps.freeTrial,
          },
        }
      : {}),
  };
};
